module.exports = __webpack_public_path__ + "static/media/health-program_p3_2.89001ba0.png";